import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';
import { cn } from '@/utils/cn';

interface GameSkeletonProps {
  className?: string;
  showName?: boolean;
  showRating?: boolean;
}

const GameSkeleton = ({ className, showName, showRating }: GameSkeletonProps) => {
  return (
    <div className={cn('flex flex-col transition-transform duration-200', className)}>
      <SkeletonParent className="w-full h-full object-cover aspect-3/4 overflow-hidden rounded-xl lg:w-30">
        <SkeletonChild className="absolute top-2 right-2 size-6 rounded-full" />
      </SkeletonParent>
      {(showName || showRating) && (
        <div className="flex flex-col gap-1 mt-2">
          {showName && <SkeletonParent className="h-4 w-3/4 rounded" />}
          {showRating && <SkeletonParent className="h-3 w-1/2 rounded" />}
        </div>
      )}
    </div>
  );
};

export default GameSkeleton;
